import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Shared cache of my conflicted rodeos (green checkmark or posted draw on the same day as another rodeo).
let cache = null;
let inflight = null;
const subs = new Set();
let timer = null;

function load() {
  inflight = api.get("/me/trade-conflicts")
    .then((r) => { cache = r.data?.conflicts || []; })
    .catch(() => { cache = cache || []; })
    .finally(() => { inflight = null; subs.forEach((f) => f(cache)); });
  return inflight;
}

if (typeof window !== "undefined") {
  // choices are mirrored to the server ~600ms after a change; refetch just after that
  window.addEventListener("rp-choices-changed", () => { clearTimeout(timer); timer = setTimeout(() => { if (subs.size) load(); }, 1200); });
}

export default function useTradeConflicts() {
  const { user } = useAuth();
  const enabled = !!user && user.account_type !== "fan";
  const [list, setList] = useState(cache || []);
  useEffect(() => {
    if (!enabled) return undefined;
    subs.add(setList);
    if (cache) setList(cache); else if (!inflight) load();
    return () => { subs.delete(setList); };
  }, [enabled]);
  const items = enabled ? list : [];
  const conflictFor = (rodeoId) => items.find((c) => c.rodeo_id === rodeoId) || null;
  return { conflicts: items, conflictFor };
}
